"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareInitialValues = exports.filterEditValues = exports.filterCreateValues = void 0;
const types_1 = require("../../../../types");
const filterCreateValues = (service) => (values) => {
    const { title, description, imageUrl, symbol, address, decimals, merchantId } = values;
    return {
        title,
        description,
        symbol,
        address,
        decimals,
        imageUrl,
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.filterCreateValues = filterCreateValues;
const filterEditValues = (service) => (values) => {
    const { title, description, imageUrl, contractStatus, merchantId } = values;
    return {
        title,
        description,
        contractStatus,
        imageUrl,
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.filterEditValues = filterEditValues;
const prepareInitialValues = (service) => ({ id, title, description, imageUrl, contractStatus, symbol, decimals, address, merchantId }) => {
    return {
        id,
        title,
        imageUrl,
        address,
        symbol,
        decimals,
        description,
        contractStatus,
        merchantId: (service === types_1.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepareInitialValues = prepareInitialValues;
//# sourceMappingURL=utils.js.map